import React from "react";
import HeaderInner from "../../Components/HeaderInner";
import { useLocation } from "react-router-dom";
import CheckCheckout from "../Checkout/CheckCheckout";

const MaintenanceCallback = () => {
  const location = useLocation();
  var url = new URLSearchParams(location.search);
  var statusValue = url.get("status");
  var message = url.get("message");

  return (
    <>
      <HeaderInner headerName={"Checkout"} />
      <main className="bg-white back-white v2">
        <CheckCheckout
          status={statusValue}
          message={message}
          urlAPI={"orders/order-receipt-by-order-type"}
          navigatUrl={"MaintenanceOrderPlaced"}
        />
      </main>
    </>
  );
};

export default MaintenanceCallback;
